/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useCallback } from 'react';
import {
    Typography,
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Radio,
    RadioGroup,
    Select,
    MenuItem,
    TextField,
    FormControl,
    FormHelperText
} from '@mui/material';
import {validateFieldPure} from '../utils/validation'
import {allowOnlyNumbers, amountRegex} from '../utils/validation-regex'
import FeeCalculator from '../utils/multi-checkbox-fee-calculation'

const DynamicForm = ({ formData, onSubmit }) => {
    const [formValues, setFormValues] = useState({});
    const [errors, setErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [calculatedAmount, setCalculatedAmount] = useState('');
    const [touched, setTouched] = useState({});

    // Initialize form values only once to prevent overwriting
    useEffect(() => {
     
        if (formData?.formFields && Object.keys(formValues).length === 0) {
            const initialValues = {};
            formData.formFields.forEach(field => {
                initialValues[field.name] = field.type === 'MULTI_CHECKBOX' ? [] : "";
            });
            setFormValues(initialValues);
            // Set query string params

            // Initialize formData based on formFields
            const initialFormData = formData.formFields.reduce((acc, field) => {
                    
                acc[field.name] = field.value || '';
                return acc;
            }, {});

            const queryParams = new URLSearchParams(window.location.search);
            queryParams.forEach((value, key) => {
                if (key in initialFormData) {
                    initialFormData[key] = value; // Update form data with query param value
                }
            });
            setFormValues(initialFormData);
        }
    }, [formData]);

     // Update "MULTI_CONDITIONAL_AMOUNT" fields whenever formData changes
        useEffect(() => {
            if (!formData || !formData.formFields) {
                return; // Exit early to prevent errors
            }
            formData.formFields.forEach((field) => {
                if (field.type === 'MULTI_CONDITIONAL_AMOUNT') {
                    updateAmount(field);
                }
            });
        }, [formValues,formData.formFields ]);




    useEffect(() => {
        validateForm();
    }, [formValues]);

    const handleChange = useCallback((event) => {
        const { name, value, type, checked } = event.target;

        setFormValues((prevValues) => {
            let newValues = { ...prevValues };

            if (type === "checkbox") {
                newValues[name] = checked
                    ? [...(prevValues[name] || []), value]
                    : prevValues[name].filter((v) => v !== value);
            } else {
                newValues[name] = value;
            }

            // if (touched[name]) {
            //     validateField(name, newValues[name]);
            // }
            

            //   const total = calculateMultiCheckAmount(formData, newValues);
            //   console.log('t',total);
            //    newValues["Amount"] = total

              // Update MULTI_AMOUNT in formValues
      const total = calculateMultiCheckAmount(formData, newValues);
      const amountField = formData.formFields.find(f => f.type === 'MULTI_AMOUNT');
      if (amountField) {
        newValues[amountField.name] = total;
      }

       // setMultiCheckBoxAmount(total);
            return newValues;
        });
    }, [touched]);

    const handleBlur = (field) => {
        // setTouched(prev => ({ ...prev, [field.name]: true }));
        setTouched(prev => {
            if (!prev[field.name]) {
                return { ...prev, [field.name]: true }; // Mark field as touched only if it wasn't before
            }
            return prev;
        });
        
        validateField(field, formValues[field.name]);
    };
const validateField = (field, value) => {
    const { isValid, error } = validateFieldPure(field, value);
    setErrors(prev => ({ ...prev, [field.name]: error }));
    return isValid;
};
    
    const validateForm = () => {
        let valid = true;
         const newErrors = {};

       
      formData.formFields.forEach(field => {
        const value = formValues[field.name];
        const { isValid, error } = validateFieldPure(field, value);

        if (!isValid) {
            newErrors[field.name] = error;
            valid = false;
        }
    });

         setErrors(newErrors);
        setIsFormValid(valid);
    };

    const updateAmount = (field) => {
        // Check if subFields exist and is an array
    if (!Array.isArray(field.subFields)) {
        return;
    }
    
    
        const matchingSubField = field.subFields.find((subField) => {
            const conditions = JSON.parse(subField.params)?.condition || [];
            const nameToIdMap = formData.formFields.reduce((acc, field) => {
                acc[field.id] = field.name;
                return acc;
            }, {});
            return conditions.every((cond) => {
                  const fieldId = String(cond.fieldId);

    if (!(fieldId in nameToIdMap)) {
        return false;
    }

    const fieldName = nameToIdMap[fieldId];
    return formValues[fieldName] === cond.fieldValue;
    
            });
        });

        if (matchingSubField && formValues[field.name] !== matchingSubField.value) {
            setCalculatedAmount(matchingSubField.value);
            // set the amount
           
            setFormValues((prev) => ({ ...prev, [field.name]: matchingSubField.value }));
        } else {
            setCalculatedAmount('');
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setTouched(
            formData.formFields.reduce((acc, field) => ({ ...acc, [field.name]: true }), {})
        );
        validateForm();
        if (isFormValid) {
            onSubmit(formValues);
        }
    };

    const getPlaceHolderValue = (field) =>{
       let options = {};
        try {
             if (field.options) {
                options = JSON.parse(field.options);
            }
        } catch (e) {
            console.warn(`Invalid JSON in options for field "${field.name}"`, e);
        }
        
        // Check regex from options
        if (options.placeHolder) {
           return options.placeHolder;
        } 
        // return empty if no place holder is there;
        return '';
    }

    const getMaxLength =(field) =>{
        let options = {};
        try {
             if (field.options) {
                options = JSON.parse(field.options);
            }
        } catch (e) {
            console.warn(`Invalid JSON in options for field "${field.name}"`, e);
        }
        
        // Check regex from options
        if (options.maxLength) {
           return options.maxLength;
        } 
        // return empty if no place holder is there;
        return 1000;
    }

// Example usage in your form component
const calculateMultiCheckAmount = (formData, formValues) => {
  if (!formData?.formFields) return 0;

  // Find the MULTI_AMOUNT field
  const amountField = formData.formFields.find(
    f => f.type === 'MULTI_AMOUNT' && f.options
  );

  if (!amountField) return 0;

  // Parse the options string to JSON
  let config;
  try {
    config = JSON.parse(amountField.options);
  } catch (e) {
    console.error('Invalid options JSON for MULTI_AMOUNT', e);
    return 0;
  }
  const nameToIdMap = formData.formFields.reduce((acc, field) => {
          acc[field.name] = field.id;
          return acc;
      }, {});
  const formDataWithIds = Object.keys(formValues).reduce((acc, key) => {
          const fieldId = nameToIdMap[key];
          if (fieldId) {
              acc[Number(fieldId)] = formValues[key];
          }
          return acc;
      }, {});
  // Use FeeCalculator to get total amount
  return FeeCalculator.totalAmount(config, formDataWithIds);
};

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 600, mx: "auto", p: 2 }}>
            {formData.formFields.map((field) => (
                <Box key={field.id} sx={{ mb: 3 }}>
                    <Typography sx={{ mb: 1 }}>
                        {field.displayName} 
                        {field.required && (
                          <Box component="span" sx={{ color: 'red' }}> *</Box>
                        )}

                    </Typography>

                    {/* Text Input */}
                    {field.type === 'TEXT' && (
                        <TextField
                            fullWidth
                            placeholder={getPlaceHolderValue(field)}
                            name={field.name}
                            value={formValues[field.name] ?? ""}
                            onChange={handleChange}
                            disabled={field.readonly}
                            onBlur={() => handleBlur(field)}
                            error={touched[field.name] && !!errors[field.name]}
                            helperText={touched[field.name] ? errors[field.name] : ""}
                            slotProps={{ htmlInput: { maxLength: getMaxLength(field) } }}
                        />
                    )}

                    {/* Number Input */}
                    {field.type === "NUMBER" && (
                        <TextField
                            fullWidth
                            name={field.name}
                            placeholder={getPlaceHolderValue(field)}
                            value={formValues[field.name] || ''}
                            required={field.required}
                            onChange={handleChange}
                            disabled={field.readonly}
                            onBlur={() => handleBlur(field)}
                            error={touched[field.name] && !!errors[field.name]}
                            helperText={touched[field.name] ? errors[field.name] : ""}
                            slotProps={{ htmlInput: { maxLength: getMaxLength(field), inputMode:"numeric" } }}
                            onBeforeInput={allowOnlyNumbers}
                        />
                    )}

                    {/* Multi Conditional Amount */}
                    {field.type === "MULTI_CONDITIONAL_AMOUNT" && (
                        <TextField
                            fullWidth
                            name={field.name}
                            type="text"
                            value={calculatedAmount || formValues[field.name] || ""}
                            required={field.required}
                            disabled={field.readonly}
                            onBlur={() => handleBlur(field)}
                            error={touched[field.name] && !!errors[field.name]}
                            helperText={touched[field.name] ? errors[field.name] : ""}
                        />
                    )}

                    {/* Multi CheckBox amount */}

                    {field.type === "MULTI_AMOUNT" && (
                        <TextField
                            fullWidth
                            name={field.name}
                            type="text"
                            value={formValues[field.name] || ""}
                            required={field.required}
                            disabled={field.readonly}
                            // onBlur={() => handleBlur(field)}
                            error={touched[field.name] && !!errors[field.name]}
                            helperText={touched[field.name] ? errors[field.name] : ""}
                        />
                    )}

                    {/* Amount Field */}
                    {field.type === "AMOUNT" && (
                        <TextField
                            fullWidth
                            name={field.name}
                            type="text"
                            value={formValues[field.name] || ''}
                            required={field.required}
                            onChange={handleChange}
                            disabled={field.readonly}
                            onBlur={() => handleBlur(field)}
                            error={touched[field.name] && !!errors[field.name]}
                            helperText={touched[field.name] ? errors[field.name] : ""}
                             onBeforeInput={amountRegex}
                        />
                    )}

                    {/* Radio Group */}
                    {field.type === 'MULTI_RADIO_LIST' && (
                        <RadioGroup
                            name={field.name}
                            disabled={field.readonly}
                            value={formValues[field.name] || ''}
                            onChange={handleChange}
                        >
                            {field.subFields.map((option) => (
                                <FormControlLabel
                                    key={option.id}
                                    value={option.value}
                                    control={<Radio />}
                                    label={option.name}
                                />
                            ))}
                        </RadioGroup>
                    )}

                    {/* Dropdown */}
                    {field.type === 'DROPDOWN' && (
                        <FormControl fullWidth error={touched[field.name] && !!errors[field.name]}>
                        <Select
                            fullWidth
                            name={field.name}
                            disabled={field.readonly}
                            value={formValues[field.name] || ""}
                            onChange={handleChange}
                            onBlur={() => handleBlur(field)}
                            // error={!!errors[field.name]}
                            error={touched[field.name] && !!errors[field.name]}
                            
                        >
                            {field.subFields.map((option) => (
                              
                                <MenuItem key={option.id} value={option.value} sx={{
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    maxWidth: 300,
                                }}>
                                      
                                    {option.name}
                                </MenuItem>
                        
                                
                            ))}
                        </Select>
                         {touched[field.name] && errors[field.name] && (
                            <FormHelperText>{errors[field.name]}</FormHelperText>
                           
                        )}
                         </FormControl>
                    )}

                    {/* Checkbox Group */}
                    {field.type === 'MULTI_CHECKBOX' && (
                        <Box display="flex" flexDirection="column">
                            {field.subFields.map((option) => (
                                <FormControlLabel
                                    key={option.id}
                                    control={
                                        <Checkbox
                                        disabled={field.readonly}
                                            name={field.name}
                                            value={option.value}
                                            checked={formValues[field.name]?.includes(option.value) || false}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={option.name}
                                />
                            ))}
                        </Box>
                    )}
                </Box>
            ))}

            {/* Submit Button */}
            <Box sx={{width:"100%", alignItems:"center", textAlign:"center", justifyItems:"center"}}>
            <Button type="submit" variant="contained" color="primary" disabled={!isFormValid} sx={{width:"100%", padding:"10px"}}>
                Proceed To Pay
            </Button>
           
            </Box>
        </Box>
    );
};

export default DynamicForm;
